/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable @typescript-eslint/interface-name-prefix */
/**
 * 请求 user-api
 */

import axios from '@/axios/api';
import { message } from 'ant-design-vue';
/** interface */
interface IUser {
  code: string;
  name: string;
  sex: number;
  age: string;
  selfIntroduction: string;
}
interface Ipass {
  oldPassword: string;
  newPassword: string;
  conPassword: string;
  code: string;
}
/** 变量 */
export const user = {
  code: '',
  name: '',
  sex: 1,
  age: '1',
  selfIntroduction: '', // 爱好
};
export class User {
  code= ''

  name= ''

  sex= 1

  age= '1'

  selfIntroduction= '' // 爱好
}
export const userrule = {
  name: [{
    required: true,
    message: '姓名不可为空',
  },
  { reg: /^[ A-Za-z0-9\u4E00-\u9FA5·。]+$/, message: '存在异常字符，请重新输入！' },
  { max: 20, min: 2, message: '请输入2-20个字符内的姓名！' }],
};
export const pass = {
  oldPassword: '',
  newPassword: '',
  conPassword: '',
};
export const passrule = {
  oldPassword: [{
    min: 6,
    max: 20,
    message: '密码长度1~20',
    trigger: 'blur',
  }],
  newPassword: [{
    min: 6,
    max: 20,
    message: '密码长度1~20',
    trigger: 'blur',
  }],
  conPassword: [{
    min: 6,
    max: 20,
    message: '密码长度1~20',
    trigger: 'blur',
  }],
};

/** method */
export const getUserInfoByCode = async (code: string) => {
  try {
    const { data: { data } } = await axios.getByCode(code);
    console.log(data, 'this is data');
    return data;
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const changeUserInfo = async (formData: IUser) => {
  try {
    const { data } = await axios.changeUserInfo({
      code: formData.code,
      age: formData.age,
      name: formData.name,
      sex: formData.sex,
      selfIntroduction: formData.selfIntroduction,
    });
    if (data.success) {
      message.success('保存成功');
    }
  } catch (error) {
    console.log(error);
  }
};

export const changePassword = async (formData: Ipass) => {
  try {
    const { data } = await axios.changePassword({
      code: formData.code,
      oldPassword: formData.oldPassword,
      newPassword: formData.newPassword,
    });
    if (data.success) {
      message.success('修改成功');
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateHeadImag = async (formData: {code: string; file: File}) => {
  try {
    const fData = new FormData();
    fData.append('code', formData.code);
    fData.append('image', formData.file);
    const { data } = await axios.updateHeadImag(fData);
    if (data.success) {
      message.success('头像上传成功');
    }
  } catch (error) {
    console.log(error);
  }
};
